// composables/useAuth.js

export const useAuth = (supabase, userStore) => {
  const restoreSession = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (session) {
      userStore.user = session.user;
      localStorage.setItem('session', JSON.stringify(session));
      if (userStore.user.id) {
        await userStore.fetchUserProfile(userStore.user.id, userStore.user);
      }
    } else {
      userStore.user.id = '';
      localStorage.removeItem('session');
    }
  };

  const handleAuthStateChange = (event, session) => {
    if (event === 'SIGNED_IN') {
      userStore.user = session.user;
      localStorage.setItem('session', JSON.stringify(session));
      if (userStore.user.id) {
        userStore.fetchUserProfile(userStore.user.id, userStore.user);
      }
    } else if (event === 'SIGNED_OUT') {
      userStore.user.id = '';
      localStorage.removeItem('session');
    }
  };

  return { restoreSession, handleAuthStateChange };
};
